import { render, staticRenderFns } from "./user_support_list.vue?vue&type=template&id=c69792c8"
import script from "./user_support_list.vue?vue&type=script&lang=js"
export * from "./user_support_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports